import React, { Component, lazy, Suspense } from "react";
import { Button, MenuItem, Menu } from "@mui/material";
//import { forgot } from "./../../../services/LoginService";
import { NavLink as RouterLink } from "react-router-dom";
const ConfigModal = lazy(() => import("../../views/admin/sections/partials/ConfigModal"));

export default class MenuDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      openConfigModal: false,
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleCloseLogOut = () => {
    window.localStorage.clear();

    this.setState({ anchorEl: null });
  };

  // resetPassword = async () => {
  //   let form = {};
  //   form["email"] = this.props.user;

  //   let response = await forgot(form);

  //   this.props.callbackForgot(response);
  //   this.setState({ anchorEl: null });
  // };

  handleResetPassword = async () => {
    this.setState({ openConfigModal: true, anchorEl: null })
  };

  handleCloseModalConfiguracion = () => {
    this.setState({ openConfigModal: false })
  };

  render() {
    return (
      <>
        <div>
          <Button
            startIcon={this.props.buttonStartIcon}
            endIcon={this.props.buttonEndIcon}
            color="inherit"
            className="button_lowecase"
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            {this.props.buttonText}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={this.state.anchorEl}
            keepMounted
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={this.handleResetPassword}>Update Password</MenuItem>
            <MenuItem
              onClick={this.handleCloseLogOut}
              component={RouterLink}
              to={{ pathname: `/login` }}
            >
              Logout
            </MenuItem>
          </Menu>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <ConfigModal
            openModalConfiguracion={this.state.openConfigModal}
            handleCloseModalConfiguracion={this.handleCloseModalConfiguracion}
          />
        </Suspense>
      </>
    );
  }
}
